/* @flow */
export const canUseDOM: boolean = ! ! (
	typeof window !== 'undefined' &&
	window.document &&
	window.document.createElement
);



// WEBPACK FOOTER //
// ./src/utils/canUseDom.js